Ext.define('SA.data.AttributeFacets', {
    singleton: true,

    getCategoriesByCountry(countryCode) {
        return this.categories.filter(({countries}) => countries.includes(countryCode));
    },

    getGroup(id) {
        return this.groupsMap[id];
    },

    getGroups() {
        var groups = [],
            groupsMap = {};

        this.all.forEach(facet => {
            var name = facet.group || facet.id,
                entry = groupsMap[name];

            if (!entry) {
                groups.push({
                    facets: entry = groupsMap[name] = [],
                    name
                });
            }

            entry.push(facet);
        });

        return groups;
    },

    getName(id) {
        return SA.localize(this.namesMap[id]);
    },

    isCategory(id) {
        return this.getGroup(id).name === 'Category';
    }
}, function(Cls) {
    Cls.categories = [
        ['popular_data', 'Popular Data'],
        ['population', 'Population'],
        ['age', 'Age'],
        ['gender', 'Gender'],
        ['race_ethnicity', 'Race & Ethnicity'],
        ['income', 'Income'],
        ['education','Education'],
        ['jobs_employment', 'Jobs & Employment'],
        ['poverty', 'Poverty', 'USA'],
        ['language', 'Language'],
        ['ancestry', 'Ancestry', 'USA'],
        ['immigration', 'Immigration', 'CAN'],
        ['households', 'Households'],
        ['family_type', 'Family Type & Marital Status'],
        ['vehicles_transportation', 'Vehicles & Transportation', 'USA'],
        ['housing', 'Housing'],
        ['market_segments', 'Market Segments'],
        ['consumer_behavior', 'Consumer Behavior'],
        ['health', 'Health'],
        ['technology', 'Technology'],
        ['finance', 'Finance', 'USA'],
        ['retail', 'Retail', 'USA'],
        ['business_counts', 'Business Counts', 'USA'],
        ['elections', 'Elections', 'USA'],
        ['other', 'Other']
    ].map(category => {
        return {
            countries: category[2] ? [category[2]] : ['CAN', 'USA'],
            group: 'Category',
            id: category[0],
            name: category[1]
        };
    });

    Cls.facets = [
        ['aboriginal', 'Aboriginal', 'Population'],
        ['citizenship', 'Citizenship', 'Population'],
        ['daytime_population', 'Daytime Population', 'Population'],
        ['in_group_quarters', 'In Group Quarters', 'Population'],
        ['religion', 'Religion', 'Population'],
        ['veterans', 'Veterans', 'Population'],

        ['children', 'Children'],
        ['gender1', 'Gender'],
        ['race', 'Race'],
        ['ethnicity', 'Ethnicity'],

        ['age_of_householder_by_income', 'Age of Householder by Income', 'Income'],
        ['assets', 'Assets, Debt, and Net Worth', 'Income'],
        ['disposable_income', 'Disposable Income', 'Income'],
        ['family_income', 'Family Income', 'Income'],
        ['household_income', 'Household Income', 'Income'],
        ['household_composition_by_income', 'Household Composition by Income', 'Income'],
        ['household_size_by_type_by_income', 'Household Size by Type by Income', 'Income'],
        ['non_family_income', 'Non-Family Income', 'Income'],
        ['race_by_income', 'Race by Income', 'Income'],

        ['education1', 'Education'],

        ['employment_industry', 'Employment Industry', 'Jobs & Employment'],
        ['employment_status', 'Employment Status', 'Jobs & Employment'],
        ['employment_type', 'Employment Type', 'Jobs & Employment'],
        ['occupation', 'Occupation', 'Jobs & Employment'],
        ['place_of_work', 'Place of Work', 'Jobs & Employment'],
        ['travel_to_work', 'Travel to Work', 'Jobs & Employment'],

        ['job_title', 'Job Title'],

        ['company_size', 'Company Size'],

        ['language1', 'Language'],

        ['immigration1', 'Immigration'],

        ['ancestry1', 'Ancestry'],

        ['age_of_householder', 'Age of Householder', 'Households'],
        ['size_of_household', 'Size of Household', 'Households'],

        ['household_type', 'Household Type'],

        ['building_size', 'Building Size', 'Housing'],
        ['condominium_status', 'Condominium Status', 'Housing'],
        ['home_heating', 'Home Heating', 'Housing'],
        ['housing_tenure', 'Housing Tenure', 'Housing'],
        ['housing_values', 'Housing Values', 'Housing'],
        ['mobility', 'Mobility', 'Housing'],
        ['mortgage_status', 'Mortgage Status', 'Housing'],
        ['rent', 'Rent', 'Housing'],
        ['structure_type', 'Structure Type', 'Housing'],
        ['vacant_units', 'Vacant Units', 'Housing'],
        ['year_built', 'Year Built', 'Housing'],

        ['lifestage_groups', 'Lifestage Groups'],
        ['market_segments1', 'Market Segments'],
        ['social_groups', 'Social Groups'],
        ['consumer_behavior1', 'Consumer Behavior'],
        ['technology1', 'Digital Lifestyle'],
        ['scarborough_market', 'Scarborough Market'],
        ['health1', 'Health'],
        ['retail1', 'Retail'],
        ['spending_categories', 'Spending Categories'],
        ['finance1', 'Financial Products'],
        ['business_counts1', 'Business Counts'],

        ['elections_contest', 'Contest'],
        ['elections_party', 'Party'],

        ['other1', 'Other'],

        ['apparel', 'Apparel'],
        ['automotive', 'Automotive'],
        ['beauty_personalcare', 'Beauty & Personal Care'],
        ['cellphone_telephone', 'Cell Phones & Telephones'],
        ['children1', 'Children'],
        ['daily_activity', 'Daily Activity'],
        ['entertainment_leisure', 'Entertainment & Leisure'],
        ['financial_services', 'Financial Services'],
        ['food_beverage', 'Food & Beverage'],
        ['giftcards_coupons_incentiveoffers', 'Gift Cards, Coupons, Etc.'],
        ['home', 'Home'],
        ['insurance', 'Insurance'],
        ['internet_catalog_shopping_mall', 'Internet, Catalogs, Etc.'],
        ['lifestyle', 'Lifestyle'],
        ['pets', 'Pets'],
        ['purchasing_decisions_influence', 'Purchasing Decisions'],
        ['store_type', 'Store Type'],
        ['technology2', 'Technology'],
        ['traditional_media', 'Traditional Media']
    ].map(facet => {
        return {
            group: facet[2],
            id: facet[0],
            name: facet[1]
        };
    });

    Cls.meta = [
        {
            id: 'type',
            name: 'Data Type'
        }, {
            id: 'year',
            name: 'Year'
        }, {
            id: 'vendor',
            name: 'Vendor'
        }, {
            id: 'dataset_series',
            name: 'Vendors & Datasets'
        }
    ];

    var all = Cls.all = Cls.categories.concat(Cls.facets).concat(Cls.meta),
        groupsMap = Cls.groupsMap = {},
        namesMap = Cls.namesMap = {};

    all.forEach(entry => {
        namesMap[entry.id] = entry.name;
    });

    Cls.getGroups().forEach(group => {
        group.facets.forEach(facet => {
            groupsMap[facet.id] = group;
        });
    });
});
